module.exports = __webpack_public_path__ + "static/media/bbb-gray-400x.ce3c2165.png";